export default __webpack_public_path__ + "static/media/teamplayerwithbg.b2d46a2a.png";